import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { FilterPresetService } from "root/services/filter/filter-preset.service";
import { Observable } from "rxjs";
import { AuthService } from "../auth-service";
import { GlobalConfigService } from "../global-config/global-config.service";
import { GridColumnService } from "root/services/grid-column/grid-column.service";
import { MibpSessionService } from "root/services/mibp-session/mibp-session.service";

@Injectable({ providedIn: 'root' })
export class FilterPresetResolver implements Resolve<void> {
  private filterPresetService = inject(FilterPresetService);
  private gridColumnService = inject(GridColumnService);
  private auth = inject(AuthService);
  private config = inject(GlobalConfigService);
  private session = inject(MibpSessionService);

  constructor() {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any>|Promise<any>|any {

    // No user exists yet for e.g. punchout users on the profile picker, and the backend returns 500
    if (this.auth.isLoggedIn() && this.session.hasUser() && this.config.enableFilterPresets) {
      return Promise.all([
        this.gridColumnService.loadColumnSelectionsForCurrentUser(),
        this.filterPresetService.loadFilterPresetsForCurrentUser()
      ]);
    }

    return;
  }
}
